import { render, staticRenderFns } from "./dialog-area.vue?vue&type=template&id=15be1ac9&"
import script from "./dialog-area.vue?vue&type=script&lang=js&"
export * from "./dialog-area.vue?vue&type=script&lang=js&"
import style0 from "./dialog-area.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports